export const AssetActionTypes = {
    LOGOUT: 'LOGOUT',
    COMMON_ERROR: 'COMMON_ERROR',

    ADD_ASSET_REQUEST: 'ADD_ASSET_REQUEST',
    ADD_ASSET_REQUEST_SUCCESS: 'ADD_ASSET_REQUEST_SUCCESS',
    ADD_ASSET_REQUEST_ERROR: 'ADD_ASSET_REQUEST_ERROR',
    ADD_ASSET_REQUEST_STATUS: 'ADD_ASSET_REQUEST_STATUS',

    ASSET_LIST_REQUEST: 'ASSET_LIST_REQUEST',
    ASSET_LIST_REQUEST_SUCCESS: 'ASSET_LIST_REQUEST_SUCCESS',
    ASSET_LIST_REQUEST_ERROR: 'ASSET_LIST_REQUEST_ERROR',

    ASSET_DETAIL_REQUEST: 'ASSET_DETAIL_REQUEST',
    ASSET_DETAIL_REQUEST_SUCCESS: 'ASSET_DETAIL_REQUEST_SUCCESS',
    ASSET_DETAIL_REQUEST_ERROR: 'ASSET_DETAIL_REQUEST_ERROR',

    ASSIGN_ASSET_REQUEST: 'ASSIGN_ASSET_REQUEST',
    ASSIGN_ASSET_REQUEST_SUCCESS: 'ASSIGN_ASSET_REQUEST_SUCCESS',
    ASSIGN_ASSET_REQUEST_ERROR: 'ASSIGN_ASSET_REQUEST_ERROR',
    ASSIGN_ASSET_REQUEST_STATUS: 'ASSIGN_ASSET_REQUEST_STATUS',

    UN_ASSIGN_ASSET_REQUEST: 'UN_ASSIGN_ASSET_REQUEST',
    UN_ASSIGN_ASSET_REQUEST_SUCCESS: 'UN_ASSIGN_ASSET_REQUEST_SUCCESS',
    UN_ASSIGN_ASSET_REQUEST_ERROR: 'UN_ASSIGN_ASSET_REQUEST_ERROR',
    UN_ASSIGN_ASSET_REQUEST_STATUS: 'UN_ASSIGN_ASSET_REQUEST_STATUS',

    UPDATE_ASSET_STATUS_REQUEST: 'UPDATE_ASSET_STATUS_REQUEST',
    UPDATE_ASSET_STATUS_REQUEST_SUCCESS: 'UPDATE_ASSET_STATUS_REQUEST_SUCCESS',
    UPDATE_ASSET_STATUS_REQUEST_ERROR: 'UPDATE_ASSET_STATUS_REQUEST_ERROR',
    UPDATE_ASSET_STATUS_REQUEST_STATUS: 'UPDATE_ASSET_STATUS_REQUEST_STATUS'
}
